import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ message, type, onClose, duration = 3000 }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onClose, 300); // Wait for animation
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`toast-container ${visible ? 'show' : 'hide'} ${type}`}>
            <div className="toast-content">
                <span className="toast-icon">
                    {type === 'success' ? '✅' : '⚠️'}
                </span>
                <span className="toast-message">{message}</span>
            </div>
            <div className="toast-progress"></div>
        </div>
    );
};

export default Toast;
